export const defaultAttemptData = {};
